export const defaultAttemptData = {};
